import React from 'react'

import type { CourseSearchPartProps } from './course-search.d';

import CourseSearch from '/react4xp/components/CourseSearch'

function CourseSearchPart(props: CourseSearchPartProps) {
    return <CourseSearch {...props} />
}

export default (props) => <CourseSearchPart {...props} />
